/* Shazory · Build Your Set · homepage handoff
   Reads ?preselect=<variantId,variantId,...> passed by the Twelve Studios pill
   and pre-populates the builder's set, then re-renders. Loaded deferred AFTER
   bundles-builder.js, so window.shazoryBundle is guaranteed to exist and the
   builder has already initialised by the time this runs.
   No-op when the param is absent (so visiting /pages/bundles directly is unchanged). */
(function () {
  'use strict';

  function apply() {
    var B = window.shazoryBundle;
    if (!B || !B.state || !B.data || !B.data.products) return;

    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var raw = params.get('preselect');
    if (!raw) return;

    var ids = raw.split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return !isNaN(n); });
    var added = 0;

    ids.forEach(function (vid) {
      var prod = B.data.products.find(function (p) {
        return p.variants && p.variants.some(function (v) { return v.id === vid; });
      });
      if (!prod) return;
      var v = prod.variants.find(function (vr) { return vr.id === vid; });
      if (!v) return;
      if (B.state.set[prod.id]) { B.state.set[prod.id].qty += 1; }
      else { B.state.set[prod.id] = { variantId: v.id, qty: 1 }; }
      added++;
    });

    /* one-shot: strip the param so a refresh or further edits don't re-inject */
    try {
      params.delete('preselect');
      var qs = params.toString();
      window.history.replaceState({}, document.title, window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) {}

    if (added) {
      /* re-render through the builder's own public path: its pill click handler calls renderAll() */
      var pill = document.querySelector('.pill.active') || document.querySelector('.pill');
      if (pill) pill.click();
      try { if (typeof gtag === 'function') gtag('event', 'bundle_preselect_applied', { count: added }); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
